import Absence from "./Absence";

export default Absence;